module.exports = __webpack_public_path__ + "whyProfistopIco.webp?a298afd29ea34f5eab3136988b23caae";